import React from 'react';
import './styles.scss';

const BundleLabel = ({ ticketsCount }) => {
  if (ticketsCount === 15) {
    return (
      <div className="single-bundle-card__ticket-label single-bundle-card__ticket-label--red">
        MOST POPULAR
      </div>
    );
  } else if (ticketsCount >= 30) {
    return (
      <div className="single-bundle-card__ticket-label single-bundle-card__ticket-label--green">
        LOWEST TICKET PRICE
      </div>
    );
  }
  return null;
};

export default BundleLabel;
